import { createFileRoute } from "@tanstack/react-router";
import { SiteShell } from "@/components/site/SiteShell";
import { OutcomeCaseStudyArticle } from "@/components/resources/OutcomeCaseStudyArticle";
import { buildHead, breadcrumbJsonLd } from "@/lib/seo";
import { articleJsonLdForPillar } from "@/components/site/PillarArticle";
import { setEdgeHtmlCache } from "@/lib/cache-headers";
import body from "../../content/resources/mp-health-squarespace-shopify-migration-case-study.es.md?raw";

const PATH = "/es/recursos/caso-mp-health-migracion-squarespace";
const ALT = "/resources/mp-health-squarespace-migration-case-study";
const TITLE = "MP Health: de Squarespace a Shopify con un sistema custom de inventario médico";
const META_TITLE = "Caso MP Health: Squarespace a Shopify · Shugert";
const DESCRIPTION = "Cómo MP Health migró de Squarespace a Shopify en 4–6 semanas con inventario por componentes, Shopify POS, SEO local y mejoras de UX móvil.";
const PUBLISHED = "2026-08-20T14:30:00.000Z";
const MODIFIED = "2026-08-20T14:30:00.000Z";

const SOURCES = [
  { label: "Perfil de Shugert Marketing", publisher: "Shopify", href: "https://www.shopify.com/partners/directory/partner/shugert-marketing" },
  { label: "MP Health", publisher: "MP Health", href: "https://mphealth.net/" },
  { label: "Shopify POS", publisher: "Shopify Help Center", href: "https://help.shopify.com/en/manual/sell-in-person" },
  { label: "Gestión de inventario", publisher: "Shopify Help Center", href: "https://help.shopify.com/en/manual/products/inventory" },
];

const RELATED = [
  { label: "Desarrollo Shopify", href: "/es/desarrollo-shopify" },
  { label: "Migración a Shopify", href: "/es/migracion-shopify" },
  { label: "SEO técnico Shopify", href: "/es/seo-tecnico-shopify" },
  { label: "Todos los casos Shopify", href: "/es/proyectos" },
];

export const Route = createFileRoute("/es/recursos/caso-mp-health-migracion-squarespace")({
  loader: async () => { await setEdgeHtmlCache(); },
  head: () => buildHead({
    locale: "es", title: META_TITLE, description: DESCRIPTION, path: PATH, altPath: ALT, type: "article",
    author: "Samuel Noriega", articleAuthor: "Samuel Noriega", articleSection: "Caso de sistemas Shopify", publishedTime: PUBLISHED, modifiedTime: MODIFIED,
    jsonLd: [
      articleJsonLdForPillar({ title: TITLE, description: DESCRIPTION, path: PATH, publishedTime: PUBLISHED, modifiedTime: MODIFIED, section: "Caso de sistemas Shopify" }),
      breadcrumbJsonLd([{ name: "Inicio", path: "/es" }, { name: "Proyectos", path: "/es/proyectos" }, { name: "Caso MP Health", path: PATH }]),
    ],
  }),
  component: () => (
    <SiteShell>
      <OutcomeCaseStudyArticle
        locale="es" path={PATH} title={TITLE}
        excerpt="Cómo una clínica migró a Shopify y conectó cada tratamiento IV vendible con los múltiples componentes de inventario que consume, junto con POS, descubrimiento local y UX móvil."
        body={body} updated="Agosto de 2026" publishedAt={PUBLISHED} modifiedAt={MODIFIED} readingMinutes={10}
        focus="Cómo Shopify se adaptó a un negocio de servicios donde un tratamiento comprado consume varios componentes físicos y las transacciones también ocurren en clínica."
        audience="Negocios de servicios y merchants especializados que evalúan Shopify cuando el modelo estándar de un producto/una unidad no representa la operación real."
        sources={SOURCES} related={RELATED}
        category="Caso de sistemas custom Shopify" backLabel="← Proyectos" backHref="/es/proyectos"
        cta={{ eyebrow: "Commerce que refleja la operación", title: "Modela la regla de negocio antes de elegir el stack de apps.", body: "Definimos relación de inventario, canales de transacción, ownership del sistema, casos de fallo y requisitos de storefront antes de comenzar desarrollo custom Shopify.", label: "Solicitar alcance de sistemas", href: "/es/cotizacion?intent=custom&source=mp-health-case-study" }}
      />
    </SiteShell>
  ),
});
